import { useCallback, useEffect, useRef, useState } from "react";
import { AgentMessage } from "@/models/agent/message";
import { MessageSchema } from "@/services/agent/agent.api.types";
import AgentEndpoints from "@/services/agent/agent.endpoint";
import { buildMessage } from "@/services/agent/agent.service";

export const useAgentStream = (
  threadId?: string,
  onMessage?: (message: AgentMessage) => void,
  onError?: (error: string) => void,
) => {
  const [connected, setConnected] = useState(false);
  const eventSourceRef = useRef<EventSource | null>(null);

  const handleStreamMessage = useCallback((event: MessageEvent) => {
    const data: MessageSchema = JSON.parse(event.data);
    const message = buildMessage(data);

    onMessage?.(message);
  }, [onMessage]);

  const handleStreamError = useCallback((event: Event) => {
    console.error("[useAgentStream] EventSource error:", event);
    onError?.("Stream connection error");
  }, [onError]);

  useEffect(() => {
    if (!threadId) return;
    console.log("[useAgentStream] Connecting to stream for thread:", threadId);

    const url = "/api/v1" + AgentEndpoints.GET_STREAM(threadId);
    const eventSource = new EventSource(url);
    eventSourceRef.current = eventSource;

    eventSource.onopen = () => {
      setConnected(true);
    };
    eventSource.onmessage = handleStreamMessage;
    eventSource.onerror = handleStreamError;

    return () => {
      console.log("[useAgentStream] Closing stream for thread:", threadId);
      eventSource.close();
      setConnected(false);
    };
  }, [threadId, handleStreamMessage, handleStreamError]);

  return { connected };
};
